var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoaderWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2125_197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 50C100 60.1067 96.9372 69.9762 91.2153 78.3073C85.4934 86.6383 77.3811 93.0398 67.948 96.6677C58.5148 100.296 48.2036 100.98 38.3739 98.6296C28.5442 96.2795 19.6574 91.0058 12.8852 83.5036C6.11292 76.0014 1.77321 66.623 0.438151 56.6048C-0.896905 46.5866 0.835381 36.399 5.40663 27.3852C9.97788 18.3713 17.1735 10.9543 26.0447 6.11213C34.916 1.26994 45.0464 -0.770152 55.1004 0.260826L53.3647 17.1874C46.7322 16.5073 40.0492 17.8531 34.1969 21.0475C28.3446 24.2419 23.5977 29.1348 20.5821 35.0812C17.5665 41.0275 16.4237 47.7482 17.3044 54.3571C18.1851 60.966 21.048 67.1529 25.5156 72.102C29.9832 77.0512 35.8458 80.5303 42.3304 82.0806C48.815 83.6309 55.6171 83.1796 61.8401 80.7863C68.0631 78.393 73.4147 74.17 77.1894 68.6741C80.9641 63.1782 82.9846 56.6673 82.9846 50H100Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2125_197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderWhite);
export default __webpack_public_path__ + "static/media/LoaderWhite.a34da805e80af06652f16f116db79120.svg";
export { ForwardRef as ReactComponent };